import { Box, ButtonBase, Typography } from '@mui/material';
import React from 'react';
import { DragBaseButton } from '../../DragBaseButton';
import { DragElement } from './DragElement';
import { DropElement } from './DropElement';
export const ToolbarButton = (props) => {
    return (React.createElement(DragBaseButton, { buttonElement: (handlePointerDown, handlePointerUp, handlePointerMove) => (React.createElement(ButtonBase, { sx: {
                height: 92,
                display: 'flex',
                flexDirection: 'column',
                p: 1,
                border: '1px solid rgba(0, 0, 0, 0.4)',
                borderRadius: 2,
                boxShadow: 1,
                bgcolor: 'background.paper',
            }, onPointerDown: handlePointerDown, onPointerUp: handlePointerUp, onPointerMove: handlePointerMove },
            React.createElement(Box, { sx: { display: 'flex' } }, props.icon),
            React.createElement(Typography, { component: 'div', sx: { mt: 1 } }, props.label))), dragElement: React.createElement(DragElement, Object.assign({}, props)), dropElement: React.createElement(DropElement, Object.assign({}, props)), createWidget: props.createWidget }));
};
